export enum ActionNoticeBadgeEnum {
  error = 'error',
  warning = 'warning',
  success = 'success',
  loading = 'loading',
}
